import React from 'react'
import Settlement from './Settlement'
import Cases from './Cases'

function CasesSettlement({errors}) {

  return (
    <div id="cases-settlement" className="section">
        <Settlement errors={errors}/>
        <Cases />
    </div>
  )
}

export default CasesSettlement